import type { DomainTreeItem } from '@/shared/types/domain';

import type { DomainHierarchyItem } from '@/entities/domain';
import { updateEntityDomains } from '@/entities/domain/api';

export const updateGlossaryCategoryDomains = async (
  glossaryCategoryId: string,
  selectedDomainId: string | null,
  hierarchy: DomainHierarchyItem[],
  currentDomains: DomainTreeItem[]
): Promise<void> => {
  await updateEntityDomains(`/glossaries/${glossaryCategoryId}`, selectedDomainId, hierarchy, currentDomains);
};
